var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',_vm._b({ref:"resizableTextarea",staticStyle:{"resize":"none","overflow":"hidden"},on:{"focus":_vm.resize,"input":_vm.resize}},'b-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }